export var LOCATIONS_METHOD = /*#__PURE__*/ function(LOCATIONS_METHOD) {
    LOCATIONS_METHOD["OS_LOCATION"] = "OS_LOCATION";
    LOCATIONS_METHOD["CUSTOM_LOCATION"] = "CUSTOM_LOCATION";
    return LOCATIONS_METHOD;
}({});

//# sourceMappingURL=types.js.map